import { removeCurrencyFormat } from './removeCurrencyFormat';

const rentAction = ['เช่า', 'rent', '租'];

export const currencyFormatCN = (price: string, action: string, language: 'th' | 'en' | 'cn'): string => {
  if (language === 'cn' && !rentAction.includes(action)) {
    const priceString = removeCurrencyFormat(price).toString();

    if (priceString.length > 3) {
      const result = priceString.slice(0, -4);

      return `${result}`;
    }

    return `${price}`;
  }

  return price;
};
